import React, { useEffect } from 'react';
import {useLocation,useNavigate } from 'react-router-dom';
import { MdFolderOpen } from "react-icons/md";
import { FiTrash } from "react-icons/fi";
import { GoBell } from "react-icons/go";
import { IoMdStarOutline } from "react-icons/io";
import { useSelector } from 'react-redux';

function DriveMenu() {

  const {pathname} = useLocation();
  
  const navigate = useNavigate();
  const roles = useSelector(state=>state.Auth.roles)


  const menu = [
    {name:'Drive Home',icon:MdFolderOpen,path:'/drive/home',id:1,color:'',roles:[]},
    {name:'Recent Activity',icon:GoBell,path:'/drive/recent_activity',id:2,color:'',roles:[]},
  ]  

  const menu1 = [
    {name:'Starred',icon:IoMdStarOutline,path:'/drive/starred',id:1,color:'',roles:[]},
    {name:'Trash Bin',icon:FiTrash,path:'/drive/trash',id:2,color:'',roles:['admin','Admin']},
  ]  

  useEffect(()=>{
         if(pathname === '/drive'){
          navigate('/drive/home')
         }
  },[pathname])

 
  return (
    <div className='hidden md:block mr-0 min-h-screen max-h-sceen border-r min-w-[170px] max-w-[170px] px-2' >

        <div className='mb-4 mt-5'>
          <h6 className=' ml-2 mb-2 font-[700] text-[12px]'>Basic Option</h6>

          {menu.map((m)=>(
              <div key={m.path} className={`flex items-center my-1 hover:bg-[#f4f5f7] px-1.5 py-1 ml-2 rounded-md relative cursor-pointer ${pathname ===  m.path && 'bg-[#f4f5f7]'}`} onClick={()=>navigate(m?.path)}>
                {pathname ===  m.path &&  <span className='border-slate-800 border-2 h-6 rounded absolute -ml-3' ></span>}
                <m.icon color='#000' style={{backgroundColor:m?.color,padding:'2px'}} size={16}  />
                <span className='text-[#000] font-[400] ml-2 text-[12px]'>{m.name}</span>
              </div>    
          ))}
        </div>

        <div className='mb-4 mt-5'>
          <h6 className=' ml-2 mb-2 font-[700] text-[12px]'>More Option</h6>

          {menu1.map((m)=>(
            <>
            {(m?.roles?.filter((f)=> roles?.includes(f))?.length > 0  || m?.roles?.length === 0) &&
              <div key={m.path} className={`flex items-center my-1 hover:bg-[#f4f5f7] px-1.5 py-1 ml-2 rounded-md relative cursor-pointer ${pathname ===  m.path && 'bg-[#f4f5f7]'}`} onClick={()=>navigate(m?.path)}>
                {pathname ===  m.path &&  <span className='border-slate-800 border-2 h-6 rounded absolute -ml-3' ></span>}
                <m.icon color='#000' style={{backgroundColor:m?.color,padding:'2px'}} size={16}  />
                <span className='text-[#000] font-[400] ml-2 text-[12px]'>{m.name}</span>
              </div>}
            </>
          ))}
        </div>


         
    </div>
  )
}

export default DriveMenu